import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { PrivateAxios } from "../api";

export const fetchPerviewsByStatus = createAsyncThunk(
  "perview/fetchPerviewsByStatus",
  async (status, { rejectWithValue }) => {
    try {
      const response = await PrivateAxios.post(
        `/api/user/construction/list`,
        { status },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.data.status) {
        return rejectWithValue(response.data.message || "Invalid status.");
      }

      return response.data.data.construction;
    } catch (error) {
      console.error("Error fetching perviews", error.message);
      return rejectWithValue(
        error.response?.data || error.request || "Failed to fetch orders"
      );
    }
  }
);

const initialState = {
  perviews: [],
  status: "idle",
  error: null,
};

const previewsConstructionStatusSlice = createSlice({
  name: "perviews",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPerviewsByStatus.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchPerviewsByStatus.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.perviews = action.payload;
      })
      .addCase(fetchPerviewsByStatus.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export default previewsConstructionStatusSlice.reducer;